module.exports = __webpack_public_path__ + "static/media/ic_arrow_forward_24px.8a749577.svg";